import React, { useState } from 'react';
import { Col, Dropdown, DropdownMenu, DropdownToggle } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import QuickMoneySpotlight from './QuickMoneySpotlight';
import QuickTaskSpotlight from './QuickTaskSpotlight';
import QuickMessageSpotlight from './QuickMessageSpotlight';
import { usePermissions } from '../Hooks/PermissionHooks';
import './WebAppsDropdown.css';

const WebAppsDropdown = () => {
    const [isWebAppDropdown, setIsWebAppDropdown] = useState<boolean>(false);
    const [showQuickMoney, setShowQuickMoney] = useState(false);
    const [showQuickTask, setShowQuickTask] = useState(false);
    const [showQuickMessage, setShowQuickMessage] = useState(false);
    const navigate = useNavigate();
    const { isAdmin } = usePermissions();
    
    // Show dropdown only for admins
    if (!isAdmin()) {
        return null;
    }
    
    const toggleWebAppDropdown = () => {
        setIsWebAppDropdown(!isWebAppDropdown);
    };
    
    const handleQuickAction = (action: string) => {
        setIsWebAppDropdown(false);
        switch(action) {
            case 'money':
                setShowQuickMoney(true);
                break;
            case 'task':
                setShowQuickTask(true);
                break;
            case 'message':
                setShowQuickMessage(true);
                break;
            case 'scan':
                navigate('/document-capture');
                break;
            case 'time':
                navigate('/time-entries/quick');
                break;
            case 'vacation':
                navigate('/absences/request');
                break;
            case 'incoming-invoices':
                navigate('/incoming-invoices');
                break;
            case 'outgoing-invoices':
                navigate('/invoices');
                break;
            case 'document-capture':
                navigate('/document-capture');
                break;
            case 'document-review':
                navigate('/document-review');
                break;
            case 'expense-reports':
                navigate('/expense-reports');
                break;
            case 'cashbook':
                navigate('/cashbook');
                break;
        }
    };
    return (
        <React.Fragment>
            <Dropdown isOpen={isWebAppDropdown} toggle={toggleWebAppDropdown} className="topbar-head-dropdown ms-1 header-item">
                <DropdownToggle tag="button" type="button" className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle">
                    <i className='bx bx-category-alt fs-22'></i>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-lg p-0 dropdown-menu-end">

                    <div className="p-3">
                        <div className="row g-2">
                            {/* Eingangsrechnungen */}
                            <Col xs={6}>
                                <button className="dropdown-icon-item btn btn-link p-2 border-0 text-decoration-none w-100" onClick={() => handleQuickAction('incoming-invoices')}>
                                    <div className="text-center">
                                        <i className="ri-file-download-line fs-20 text-primary mb-1"></i>
                                        <div className="small">Eingangsrechnungen</div>
                                    </div>
                                </button>
                            </Col>
                            
                            {/* Ausgangsrechnungen */}
                            <Col xs={6}>
                                <button className="dropdown-icon-item btn btn-link p-2 border-0 text-decoration-none w-100" onClick={() => handleQuickAction('outgoing-invoices')}>
                                    <div className="text-center">
                                        <i className="ri-file-upload-line fs-20 text-success mb-1"></i>
                                        <div className="small">Ausgangsrechnungen</div>
                                    </div>
                                </button>
                            </Col>
                            
                            {/* Dokumente erfassen */}
                            <Col xs={6}>
                                <button className="dropdown-icon-item btn btn-link p-2 border-0 text-decoration-none w-100" onClick={() => handleQuickAction('document-capture')}>
                                    <div className="text-center">
                                        <i className="ri-scan-2-line fs-20 text-info mb-1"></i>
                                        <div className="small">Dokumente erfassen</div>
                                    </div>
                                </button>
                            </Col>
                            
                            {/* Dokumente prüfen */}
                            <Col xs={6}>
                                <button className="dropdown-icon-item btn btn-link p-2 border-0 text-decoration-none w-100" onClick={() => handleQuickAction('document-review')}>
                                    <div className="text-center">
                                        <i className="ri-file-search-line fs-20 text-warning mb-1"></i>
                                        <div className="small">Dokumente prüfen</div>
                                    </div>
                                </button>
                            </Col>
                            
                            {/* Belegabrechnung */}
                            <Col xs={6}>
                                <button className="dropdown-icon-item btn btn-link p-2 border-0 text-decoration-none w-100" onClick={() => handleQuickAction('expense-reports')}>
                                    <div className="text-center">
                                        <i className="ri-file-list-3-line fs-20 text-danger mb-1"></i>
                                        <div className="small">Belegabrechnung</div>
                                    </div>
                                </button>
                            </Col>
                            
                            {/* Kassenbuch */}
                            <Col xs={6}>
                                <button className="dropdown-icon-item btn btn-link p-2 border-0 text-decoration-none w-100" onClick={() => handleQuickAction('cashbook')}>
                                    <div className="text-center">
                                        <i className="ri-money-euro-circle-line fs-20 text-primary mb-1"></i>
                                        <div className="small">Kassenbuch</div>
                                    </div>
                                </button>
                            </Col>
                        </div>
                    </div>
                </DropdownMenu>
            </Dropdown>
            
            {/* Quick Action Modals */}
            {showQuickMoney && (
                <QuickMoneySpotlight 
                    isOpen={true}
                    toggle={() => {
                        setShowQuickMoney(false);
                    }}
                />
            )}
            
            {showQuickTask && (
                <QuickTaskSpotlight 
                    isOpen={true}
                    onClose={() => setShowQuickTask(false)}
                    onTaskCreated={() => setShowQuickTask(false)}
                />
            )}
            
            {showQuickMessage && (
                <QuickMessageSpotlight 
                    isOpen={true}
                    onClose={() => setShowQuickMessage(false)}
                />
            )}
        </React.Fragment>
    );
};

export default WebAppsDropdown;